import React from 'react';
import PropTypes from 'prop-types';
import { Image } from './styles';

import {
  QuestionLabel,
  Container,
} from '../styles';

const ImageQuestionType = ({
  label,
  index,
  imageUrl,
}) => (
  <Container>
    <QuestionLabel>{`Question ${index + 1}: ${label} (Image)`}</QuestionLabel>
    <Image src={imageUrl} size="medium" />
  </Container>
);

// proptypes
ImageQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default ImageQuestionType;
